import { HASHTAG } from "@/lib/wedding-data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#471016] text-[#FDFBF7] overflow-hidden">
      <div className="py-10 border-b border-[#D4AF37]/20 overflow-hidden">
        <div className="marquee-track flex whitespace-nowrap gap-12 w-max">
          {Array.from({ length: 10 }).map((_, i) => (
            <span key={i} className="font-serif italic text-3xl text-[#E1C699]/80">
              {HASHTAG} · Vishi & Piyush · January 24, 2027 ·
            </span>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <p className="font-serif text-4xl md:text-5xl tracking-tighter">
            Vishi <span className="italic text-[#E1C699]">&</span> Piyush
          </p>
          <p className="mt-3 text-sm text-[#FDFBF7]/60">
            Sunday, January 24, 2027 · Lelux Resort, Gurgaon
          </p>
        </div>
        <p className="text-xs uppercase tracking-[0.3em] text-[#E1C699]/70">
          Made with love · {HASHTAG}
        </p>
      </div>
    </footer>
  );
}
